export default function CannotProcessDiff() {
  return <div>Sorry. The diff could not be processed.</div>;
}
